import { useCallback } from 'react';

import { MixedItem } from 'store/railsBuilder/reducer.types';

type Props = {
    item: MixedItem;
    index: number;
    onPressPossibleDeeplinkItem: (
        onPress: () => void,
        tuneToLive?: boolean,
    ) => void;
    onPress: (item: MixedItem, index: number) => void;
};

export default function useGalleryOnPress({
    item,
    index,
    onPress,
    onPressPossibleDeeplinkItem,
}: Props) {
    const onPressItem = useCallback(
        () => onPress(item, index),
        [onPress, item, index],
    );

    return useCallback(() => {
        onPressPossibleDeeplinkItem(onPressItem, false);
    }, [item, onPressItem, onPressPossibleDeeplinkItem]);
}
